import i18n from 'i18n';

export class OrderStatusNotEligibleError extends Error {
  constructor() {
    super(i18n.t('apiErrors.orderStatusNotEligible'));
  }
}

export class OrderBranchNoCompanyError extends Error {
  constructor() {
    super(i18n.t('apiErrors.orderBranchNoCompany'));
  }
}
